export const DistributionType = {
  Auto: "Auto",
  Manual: "Manual",
};
export const TaUserGroupType = {
  ADMIN: "ADMIN",
  USER: "USER",
  SUPERADMIN: "SUPERADMIN",
};
export const TravelAgentType = {
  AGENT: 1,
  API: 2,
  COMPANY: 3,
  TRADING: 4,
};
export const convertTransactionType = (transactionType) => {
  let result = "";
  if (transactionType === "AR_ADD") {
    result = "ar_client_add_bill";
  }
  if (transactionType === "AR_UPDATE") {
    result = "ar_client_change_bill";
  }
  if (transactionType === "AR_DELETE") {
    result = "ar_client_delete_bill";
  }
  if (transactionType === "PAYMENT_ADD") {
    result = "ar_client_add_pay";
  }
  if (transactionType === "PAYMENT_UPDATE") {
    result = "ar_client_change_payment";
  }
  if (transactionType === "PAYMENT_DELETE") {
    result = "ar_client_delete_payment";
  }
  if (transactionType === "AR_SMS_ADD") {
    result = "ar_client_pay_bill";
  }
  if (transactionType === "DISTRIBUTION_ADD") {
    result = "ar_client_add_distribution";
  }
  if (transactionType === "DISTRIBUTION_UPDATE") {
    result = "ar_client_edit_distribution";
  }
  if (transactionType === "DISTRIBUTION_DELETE") {
    result = "ar_client_delete_distribution";
  }
  return result;
};
export const TransactionAccountTransactionType = [
  { title: "ar_client_reduce_price_booking", value: "DISTRIBUTION_BOOKING", variant: "success" },
  { title: "ar_client_auto_distribution_sms", value: "DISTRIBUTION_SMS", variant: "danger" },
];

export const ArPaymentStatus = [
  { title: "ar_client_paid", value: "PAY", variant: "success" },
  { title: "ar_client_unpaid", value: "NO", variant: "danger" },
];
export const PaymentDetailTypeStatus = [
  { title: "ar_client_refund", value: "REFUND", variant: "dark" },
  { title: "ar_client_top_up", value: "PAYMENT", variant: "dark" },
  { title: "ar_client_adjust", value: "MODIFY", variant: "dark" },
];
export const TravelAgentIsOverDraftStatus = [
  { title: "ar_client_allow", value: true, variant: "success" },
  { title: "ar_client_not_allow", value: false, variant: "danger" },
];
export const SmsDistributionStatus = [
  { title: "ar_client_allotted", value: "YES", variant: "success" },
  { title: "ar_client_not_allotment", value: "NO", variant: "danger" },
];
export const SmsStatus = [
  { title: "ar_client_syntax_error", value: "ERROR", variant: "danger" },
  { title: "ar_client_draft_fixed", value: "DRAFT", variant: "primary" },
  { title: "ar_client_completed", value: "MODIFIED", variant: "success" },
  { title: "ar_client_syntax_correct", value: "SUCCESSFUL", variant: "success" },
];
export const DistributionStatus = [
  { title: "ar_client_un_created_ap", value: "UNCREATEDAP", variant: "danger" },
  { title: "ar_client_creating_ap", value: "CREATINGAP", variant: "primary" },
  { title: "ar_client_created_ap", value: "CREATEDAP", variant: "success" },
];
export const ArPaymentDistributionStatus = [
  { title: "ar_client_allotted", value: "FULL", variant: "success" },
  { title: "ar_client_not_allotment", value: "NO", variant: "danger" },
  { title: "ar_client_distributing", value: "INPROCESS", variant: "primary" },
];
export const ApPaymentStatus = [
  { title: "ap_client_approve", value: "BROWSE", variant: "success" },

  { title: "golf_common_confirm", value: "CONFIRM", variant: "success" },
  { title: "Chi hết", value: "FULL", variant: "success" },
  { title: "Đang chi", value: "INPROCESS", variant: "primary" },
  { title: "Chưa chi", value: "NO", variant: "danger" },
];
export const CommonStatus = [
  { title: "ar_client_active", value: true, variant: "success" },
  { title: "ar_client_in_active", value: false, variant: "danger" },
];
export const CommonActiveStatus = [
  { title: "ar_client_active", value: 1, variant: "success" },
  { title: "ar_client_in_active", value: 0, variant: "danger" },
];
export const convertPaymentDetailTypeStatus = (title) => {
  let dO = { title: title, variant: "" };

  PaymentDetailTypeStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};
export const convertTravelAgentIsOverDraftStatus = (title) => {
  let dO = { title: title, variant: "" };

  TravelAgentIsOverDraftStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};
export const convertDistributionStatus = (title) => {
  let dO = { title: title, variant: "" };

  DistributionStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};
export const convertSmsStatus = (title) => {
  let dO = { title: title, variant: "" };

  SmsStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};

export const convertSmsDistributionStatus = (title) => {
  let dO = { title: title, variant: "" };

  SmsDistributionStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};
export const convertCommonStatus = (title) => {
  let dO = { title: title, variant: "" };

  CommonStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};
export const convertCommonActiveStatus = (title) => {
  let dO = { title: title, variant: "" };

  CommonActiveStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};
export const convertArPaymentStatus = (title) => {
  let dO = { title: title, variant: "" };
  ArPaymentStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};
export const convertArPaymentDistributionStatus = (title) => {
  let dO = { title: title, variant: "" };

  ArPaymentDistributionStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};
export const convertApPaymentStatus = (title) => {
  let dO = { title: title, variant: "" };

  ApPaymentStatus.forEach((op) => {
    if (title === op.value) dO = { title: op.title, variant: op.variant };
  });

  return dO;
};
